import React from "react";

// components
import LoginButton from "core/SiteHeader/components/LoginButton.js";

// component
const UnauthMenu = () => {
    return <LoginButton />;
};

export default UnauthMenu;
